export const textFieldStyles = () => ({});
export const amountFieldStyles = () => ({});
export const infoFieldStyles = () => ({});
export const selectFieldStyles = () => ({});
export const datePickerFieldStyles = () => ({});
